// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { isHTMLElement } from '../../internal/utils/dom';
/** Checks if a node is a Text node. */
export function isTextNode(node) {
    return (node === null || node === void 0 ? void 0 : node.nodeType) === Node.TEXT_NODE;
}
/**
 * Checks if a node is a BR element, optionally matching a specific data-id.
 * @param dataId optional data-id to match (e.g., ElementType.TrailingBreak)
 */
export function isBRElement(node, dataId) {
    if ((node === null || node === void 0 ? void 0 : node.nodeName) !== 'BR' || !isHTMLElement(node)) {
        return false;
    }
    if (dataId !== undefined) {
        return node.getAttribute('data-id') === dataId;
    }
    return true;
}
export function isTextToken(token) {
    return token.type === 'text';
}
export function isBreakTextToken(token) {
    return token.type === 'break';
}
export function isTriggerToken(token) {
    return token.type === 'trigger';
}
export function isReferenceToken(token) {
    return token.type === 'reference';
}
export function isPinnedReferenceToken(token) {
    return isReferenceToken(token) && token.pinned === true;
}
//# sourceMappingURL=type-guards.js.map